import { render, staticRenderFns } from "./index.vue?vue&type=template&id=26548e17&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26548e17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26548e17')) {
      api.createRecord('26548e17', component.options)
    } else {
      api.reload('26548e17', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=26548e17&scoped=true", function () {
      api.rerender('26548e17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/cdkey/index.vue"
export default component.exports